import { usePortalData } from '../data/usePortalData';
import { UserTicketViewOption } from '../data/types';
export const useHasCompanyPermissions = () => {
  const {
    data
  } = usePortalData();
  return !!(data !== null && data !== void 0 && data.userTicketViewOptions.includes(UserTicketViewOption.COMPANY));
};